import { openDB } from "idb";
import { api } from "@/lib/api";

const dbp = openDB("fleetview-offline", 1, { upgrade(db) { db.createObjectStore("photos", { keyPath: "client_id" }); } });

export async function queuePhoto({ file, vehicle_id, panel, kind, note, issue_id }) {
  const client_id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  await (await dbp).put("photos", { client_id, blob: file, name: file.name, type: file.type, vehicle_id, panel, kind, note, issue_id, queued_at: Date.now() });
  return client_id;
}

export async function pendingCount() { return (await dbp).count("photos"); }

export async function uploadPhoto(p) {
  const fd = new FormData();
  fd.append("file", p.blob || p.file, p.name || p.file?.name || "photo.jpg");
  ["vehicle_id", "panel", "kind", "note", "issue_id", "client_id"].forEach((k) => p[k] && fd.append(k, p[k]));
  return api.post("/photos", fd, { headers: { "Content-Type": "multipart/form-data" } });
}

export async function flushQueue() {
  const db = await dbp;
  const items = await db.getAll("photos");
  let ok = 0;
  for (const p of items) {
    try { await uploadPhoto(p); await db.delete("photos", p.client_id); ok++; } catch (e) { if (e?.response && e.response.status !== 0 && e.response.status < 500) await db.delete("photos", p.client_id); }
  }
  return ok;
}

export function startQueueSync(onFlushed) {
  const run = async () => { if (!navigator.onLine) return; const n = await flushQueue(); if (n) onFlushed?.(n); };
  window.addEventListener("online", run);
  run();
  return () => window.removeEventListener("online", run);
}
